import { createAction } from 'redux-act';

export const login = createAction('user/LOG_IN');
export const loginFailure = createAction('user/LOG_IN_FAILURE');
export const logout = createAction('user/LOG_OUT');
export const setUser = createAction('user/SET_USER');
export const setAuthentication = createAction('user/SET_AUTHENTICATION');
export const trackAuthentication = createAction('user/TRACK_AUTHENTICATION');
export const clearAuthentication = createAction('user/CLEAR_AUTHENTICATION');
export const dismissSearchMessaging = createAction('user/DISMISS_SEARCH_MESSAGING');
export const dismissLoginTooltip = createAction('user/DISMISS_LOGIN_TOOLTIP');
export const dismissWelcomeMessage = createAction('user/DISMISS_WELCOME_MESSAGE');
